import { EquipmentStatusCategoryOptions } from '@models/EquipmentStatus.model';
import { getStatusColor } from '@utils';

import { CustomOption, Circle } from './StatusBadge.styles';

interface IStatusBadge {
  label: EquipmentStatusCategoryOptions;
  name?: string;
}

export const StatusBadge = ({ label, name }: IStatusBadge) => {
  return (
    <CustomOption>
      <Circle color={getStatusColor(label)} />
      {name || label}
    </CustomOption>
  );
};
